import { createApp } from 'vue';
import { plugin, defaultConfig } from '@formkit/vue';
import KIWFormApp from './apps/KIWFormApp/KIWFormApp.vue';
import WyreContactApp from './apps/WyreContactApp/WyreContactApp.vue';
import T from './plugins/translate-plugin';
import './sass/main.scss';
import formkitConfig from './formkit.config';
import InfoTooltip from './components/InfoTooltip/InfoTooltip.vue';

const $kiwContainer = document.querySelector('#kiw-app');
if ($kiwContainer) {
  const app = createApp(KIWFormApp);
  app.use(T);
  app.use(plugin, defaultConfig(formkitConfig));
  app.component('InfoTooltip', InfoTooltip);
  app.mount($kiwContainer);
}

const $contactContainer = document.querySelector('#wyre-contact-app');
if ($contactContainer) {
  const app = createApp(WyreContactApp);
  app.use(T);
  app.use(plugin, defaultConfig(formkitConfig));
  app.component('InfoTooltip', InfoTooltip);
  app.mount($contactContainer);
}
